import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ShareLink } from '../models/sharelink';
import { ShareSettings } from '../models/sharesettin';
import { SiteResDialogComponent } from '../sites/site-restriction/siteres-dialog.component';
import { UploadShareData } from '../upload/UploadShareData';
import { APIService } from './api.component';
import { Constants } from './constants';
import { Encryption } from './encryption.component';
import { SharedService } from './shared.service';
import { ShareUtils } from './shareutils';

declare var $: any;

@Injectable({
  providedIn: 'root'
})
export class Utils {

  /**
   * Remove this method once move to 5.6
   * @param data 
   * @param id 
   * @returns 
   */
  getSiteTemp(data: Object, id: any): any {
    var result = data['site'][0]
    for (var site of data['site']) {
      if (site.id == id) {
        result = site
        break
      }
    }
    return result
  }


  openErrorDialog(data: { errorData: any; }, dialog: MatDialog, callback: (item: any) => void) {
    if (dialog.openDialogs.length == 0 || data.errorData['errorCode'] == Constants.UNSUPPORTED_FILE_FOLDER) {
      let dialogConfig = new MatDialogConfig();
      dialogConfig.data = data;
      if (dialogConfig.data.errorData.refCode == 432 || dialogConfig.data.errorData.refCode == 433 || dialogConfig.data.errorData.refCode == 434) {
        dialogConfig = {
          /*  position: {
             top: '0px',
             left: '0px'
           },
           height: '100%',
           width: '100%',*/
          panelClass: 'full-screen-modal',
          maxWidth: '100vw',
          maxHeight: '100vh',
          height: '100%',
          width: '100%',
          data: data
        };
      }
      dialog.open(SiteResDialogComponent, dialogConfig).afterClosed()
        .subscribe(callback);
    }
  }


  openConfirmationDialog(data: { errorData: any; }, dialog: MatDialog, callback: (item: any) => void) {
    if (dialog.openDialogs.length == 0 || data.errorData['errorCode'] == Constants.UNSUPPORTED_FILE_FOLDER) {
      let dialogConfig = new MatDialogConfig();
      dialogConfig.data = data;
      dialogConfig.data.errorData.isFullScreen = true
      dialogConfig = {
        /*  position: {
           top: '0px',
           left: '0px'
         },
         height: '100%',
         width: '100%',*/
        panelClass: 'full-screen-modal',
        maxWidth: '100vw',
        maxHeight: '100vh',
        height: '100%',
        width: '100%',
        data: data
      };
      dialog.open(SiteResDialogComponent, dialogConfig).afterClosed()
        .subscribe(callback);
    }
  }

  typeknown: boolean = true
  public getFileIcon(type: string) {
    var localType = this.getLocalType(type);
    this.typeknown = true;
    if (this.getFileIconForImages(localType).localeCompare(type) != 0)
      return this.getFileIconForImages(localType);
    else if (this.getFileIconForOfficeFiles(localType).localeCompare(type) != 0)
      return this.getFileIconForOfficeFiles(localType);
    else if (this.checkForVideoType1(localType) || this.checkForVideoType2(localType) || this.checkForVideoType3(localType)) {
      this.typeknown = true;
      localType = "video";
    }
    else if (this.checkZipFile(localType)) {
      this.typeknown = true;
      localType = "zip";
    }
    else if (this.checkEmailFile(localType)) {
      this.typeknown = true;
      localType = "email";
    }
    else if (this.getFileIconForPhotoshop(localType).localeCompare("") != 0)
      return this.getFileIconForPhotoshop(localType);
    else
      localType = this.getOtherFileIcon(localType);

    if (this.typeknown)
      return localType;
    else
      return "unknown";
  }

  /**
   * To check if file format is email or msg
   *
   * @param localType
   * @return
   */
  private checkEmailFile(localType: string) {
    return ("email".toLocaleLowerCase() === localType.toLocaleLowerCase() || "msg".toLocaleLowerCase() === localType.toLocaleLowerCase() || "eml".toLocaleLowerCase() === localType.toLocaleLowerCase());
  }

  /**
   * Get icons for photoshop files
   *
   * @param localType
   * @return
   */
  private getFileIconForPhotoshop(localType: string) {
    var newlocalType = "";
    if ("psd".toLocaleLowerCase() === localType.toLocaleLowerCase())
      newlocalType = "psd";
    else if ("indd".toLocaleLowerCase() === localType.toLocaleLowerCase())
      newlocalType = "indd";
    return newlocalType;
  }


  /**
   * To Check if file format is zip or jar
   *
   * @param localType
   * @return
   */
  private checkZipFile(localType: string) {
    return ("zip".toLocaleLowerCase() === localType.toLocaleLowerCase() || "jar".toLocaleLowerCase() === localType.toLocaleLowerCase());
  }

  /**
   * To get common file type for files to show proper icon for files in browse and recent list
   *
   * @param localType : exact file type
   * @return : converted common file type
   */
  private getOtherFileIcon(localType: string) {
    if (this.checkFileType(localType)) {
      this.typeknown = true;
      return "file";
    }
    else if (this.checkHtmlType(localType)) {
      this.typeknown = true;
      return "html";
    }
    else if ("pdf".toLocaleLowerCase() === localType.toLocaleLowerCase()) {
      this.typeknown = true;
      return "pdf";
    }
    else if (this.chedkAudioType(localType)) {
      this.typeknown = true;
      return "audio";
    }
    else if ("rar".toLocaleLowerCase() === localType.toLocaleLowerCase()
      || "pkg".toLocaleLowerCase() === localType.toLocaleLowerCase()) {
      this.typeknown = true;
      return "dmg";
    }
    else if (this.checkVectorType(localType)) {
      this.typeknown = true;
      return "vector";
    }
    else if ("adp".toLocaleLowerCase() === localType.toLocaleLowerCase()) {
      this.typeknown = true;
      return "adp";
    }
    else if ("dwg".toLocaleLowerCase() === localType.toLocaleLowerCase()) {
      this.typeknown = true;
      return "dwg";
    }
    return localType;
  }

  /**
   * To mark it video file if local type matches with given video types
   *
   * @param localType :exact video file type
   * @return true if matches
   */
  private checkForVideoType1(localType: string) {
    return "mov".toLocaleLowerCase() === localType.toLocaleLowerCase()
      || "mp4".toLocaleLowerCase() === localType.toLocaleLowerCase()
      || "avi".toLocaleLowerCase() === localType.toLocaleLowerCase()
      || "flv".toLocaleLowerCase() === localType.toLocaleLowerCase();
  }

  /**
   * To mark it video file if local type matches with given video types
   *
   * @param localType :exact video file type
   * @return true if matches
   */
  private checkForVideoType2(localType: string) {
    return "wmv".toLocaleLowerCase() === localType.toLocaleLowerCase()
      || "m4v".toLocaleLowerCase() === localType.toLocaleLowerCase()
      || "mpg".toLocaleLowerCase() === localType.toLocaleLowerCase()
      || "mpeg".toLocaleLowerCase() === localType.toLocaleLowerCase();
  }

  /**
   * To mark it video file if local type matches with given video types
   *
   * @param localType :exact video file type
   * @return true if matches
   */
  private checkForVideoType3(localType: string) {
    return "mkv".toLocaleLowerCase() === localType.toLocaleLowerCase()
      || "webm".toLocaleLowerCase() === localType.toLocaleLowerCase()
      || "f4v".toLocaleLowerCase() === localType.toLocaleLowerCase()
      || "f4p".toLocaleLowerCase() === localType.toLocaleLowerCase();
  }

  /**
   * To mark it doc file if local type matches with given file types
   *
   * @param localType :exact doc file type
   * @return true if matches
   */
  private checkFileType(localType: string) {
    return "rtf".toLocaleLowerCase() === localType.toLocaleLowerCase()
      || "txt".toLocaleLowerCase() === localType.toLocaleLowerCase()
      || "ods".toLocaleLowerCase() === localType.toLocaleLowerCase()
      || "nef".toLocaleLowerCase() === localType.toLocaleLowerCase();
  }

  /**
   * To mark it html file if local type matches with given file types
   *
   * @param localType :exact file type
   * @return true if matches
   */
  private checkHtmlType(localType: string) {
    return "htm".toLocaleLowerCase() === localType.toLocaleLowerCase()
      || "xml".toLocaleLowerCase() === localType.toLocaleLowerCase()
      || "xhtml".toLocaleLowerCase() === localType.toLocaleLowerCase()
      || "js".toLocaleLowerCase() === localType.toLocaleLowerCase();
  }

  /**
   * To mark it audio file if local type matches with given file types
   *
   * @param localType :exact audio file type
   * @return true if matches
   */
  private chedkAudioType(localType: string) {
    return "mp3".toLocaleLowerCase() === localType.toLocaleLowerCase()
      || "wav".toLocaleLowerCase() === localType.toLocaleLowerCase()
      || "wma".toLocaleLowerCase() === localType.toLocaleLowerCase()
      || "m4a".toLocaleLowerCase() === localType.toLocaleLowerCase();
  }

  /**
   * To mark it vector file if local type matches with given file types
   *
   * @param localType :exact file type
   * @return true if matches
   */
  private checkVectorType(localType: string) {
    return "svg".toLocaleLowerCase() === localType.toLocaleLowerCase()
      || "sketch".toLocaleLowerCase() === localType.toLocaleLowerCase()
      || this.checkVectorType1(localType);
  }

  /**
   * To mark it vector file if local type matches with given file types
   *
   * @param localType :exact file type
   * @return true if matches
   */
  private checkVectorType1(localType: string) {
    return "eps".toLocaleLowerCase() === localType.toLocaleLowerCase()
      || "ico".toLocaleLowerCase() === localType.toLocaleLowerCase()
      || "cdr".toLocaleLowerCase() === localType.toLocaleLowerCase();
  }

  /**
   * get exact file type
   *
   * @param type
   * @return file type if not null or returns empty string
   */
  getLocalType(type: string) {
    return type != null ? type : "";
  }

  /**
   * To get file icon string for given image file types
   *
   * @param localType :exact file type
   * @return fileicon type
   */
  private getFileIconForImages(localType: string) {
    var newlocalType = localType;
    if ("jpg".toLocaleLowerCase() === newlocalType.toLocaleLowerCase() || "jpeg".toLocaleLowerCase() === newlocalType.toLocaleLowerCase())
      newlocalType = "jpg";
    else if ("png".toLocaleLowerCase() === newlocalType.toLocaleLowerCase())
      newlocalType = "png";
    else if ("gif".toLocaleLowerCase() === newlocalType.toLocaleLowerCase())
      newlocalType = "gif";
    else if ("bmp".toLocaleLowerCase() === newlocalType.toLocaleLowerCase())
      newlocalType = "bmp";
    else if ("tiff".toLocaleLowerCase() === newlocalType.toLocaleLowerCase())
      newlocalType = "tiff";
    else
      this.typeknown = false;
    return newlocalType;
  }

  formatBytes(bytes, decimals = 2) {
    if (bytes === 0) {
      return "0 Bytes";
    }
    const k = 1024;
    const dm = decimals <= 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  }

  /**
   * To get file icon string for given image file types
   *
   * @param localType :exact file type
   * @return fileicon type
   */
  private getFileIconForOfficeFiles(localType: string) {
    var newlocalType = localType;
    if ("doc".toLocaleLowerCase() === newlocalType.toLocaleLowerCase() || "gdoc".toLocaleLowerCase() == newlocalType.toLocaleLowerCase() || "docx".toLocaleLowerCase() == newlocalType.toLocaleLowerCase()) {
      newlocalType = "word";
    } else if ("xls".toLocaleLowerCase() === newlocalType || "xlsx".toLocaleLowerCase() === newlocalType || "gsheet".toLocaleLowerCase() === newlocalType) {
      newlocalType = "excel";
    } else if ("ppt".toLocaleLowerCase() === newlocalType || "pptx".toLocaleLowerCase() === newlocalType) {
      newlocalType = "powerpoint";
    }
    return newlocalType;
  }

  public groupBy(list, keyGetter) {
    const map = new Map();
    list.forEach((item) => {
      const key = keyGetter(item);
      const collection = map.get(key);
      if (!collection) {
        map.set(key, [item]);
      } else {
        collection.push(item);
      }
    });
    return map;
  }

  setContentHeight(isButtonVisible: boolean, isShareButton: boolean, isUpload: boolean, isSettings: boolean, isRecent: boolean) {
    var windowHeight = window.innerHeight ? window.innerHeight : $(window).height();
    var footerHeight = $('.msTeam-modal-footer').outerHeight() || 2;
    var footerHeightRight = $('.global-footer').outerHeight() || 2;
    var modalBodyTop = $('.msTeam-modalBodyTop').outerHeight();
    var contentHeight;

    if (isUpload && isShareButton)
      contentHeight = windowHeight - 34;
    else if (isButtonVisible && isShareButton)
      contentHeight = windowHeight - 7;
    else if (isSettings && isShareButton)
      contentHeight = windowHeight - 64;
    else if (isRecent && isShareButton)
      contentHeight = windowHeight - 16;
    else if (isShareButton)
      contentHeight = windowHeight - 7;
    else
      contentHeight = windowHeight - 12;
    var finalHeight = modalBodyTop == undefined ? contentHeight - footerHeight - footerHeightRight : contentHeight - footerHeight - footerHeightRight - modalBodyTop
    $('.msTeam-modalBodyScroll').css({
      'height': finalHeight
    });
  }

  setBreadCrump() {
    $.fn.breadcrumbs = function (options) {
      var el = $(this);

      // truncate individual titles if over set length
      $('a', el).each(function () {
        var crumbTitle = $(this).text();
        if (crumbTitle.length > options.crumbMaxLength) {
          $(this).text(
            $.trim(crumbTitle).substring(0, 40).split(" ").slice(0, -1).join(" ") + "…"
          );
        }
      });

      // remove the link from the current page crumb
      // $('.active', el).replaceWith(
      // $('<span/>').text($('.active', el).text())
      // );

      var crumbs = $.map($('a', el).toArray(), function (x) {
        return x.outerHTML;
      });

      //  if truncation needed
      if (crumbs.length > options.maxLevels) {
        var firstCrumbs = crumbs.slice(0, options.startCrumbs);
        var hideCrumbs = '<a mat-button class="dropdown open" title="Show all">…</a>';
        //var hideCrumbs = '<span class="dropdown inlineBlock"><a href="#" class="dropdown-toggle">...</a></span>';
        //var hideCrumbs1 = '<ul class="dropdown-menu 12"><li><a href="#">share</a></li><li><a href="#">share</a></li><li><a href="#">share</a></li></ul>';
        var lastCrumbs = crumbs.slice(crumbs.length - options.endCrumbs);
        var newCrumbs = firstCrumbs.concat([hideCrumbs]).concat(lastCrumbs);
        el.html(options.intro + newCrumbs);
      } else {
        // var hideCrumbs1= $.html();
        //$.html("<br><div class='new' id='" + id + "'>Hello</div>");
        //el.html(options.intro + crumbs.join(options.separator));
      }

      // show the hidden breadcrumbs when ellipsis is clicked
      $('[title]', el).click(function () {
        $(".dropdown").append("<ul class='dropdown-menu show'><li><a href=''>share</a></li><li><a href='#'>share</a></li><li><a href='#'>share</a></li></ul>");
      })
      //$("ul.dropdown-menu").mouseleave(function() {
      $('.dropdown').off('mouseleave', 'ul.dropdown-menu').on('mouseleave', 'ul.dropdown-menu', function (e) {
        $(this).remove();
      });
    };

    $(document).ready(function (e) {
      $('.breadcrumbs').breadcrumbs({
        intro: '',
        separator: ' > ',
        maxLevels: 5,
        startCrumbs: 2,
        endCrumbs: 2,
        crumbMaxLength: 40
      });
    });
  }

  public getEncryptedString(text: string) {
    return new Encryption().encryptString(text);
  }

  public getEncryptedHeaderString(text: string) {
    var ticks = this.getUtcTicks(new Date().getTime());
    var textToEncrypt = text + Constants.DATA_SEP + ticks;
    var key = new Encryption().encryptString(textToEncrypt)
    return key
  }

  public getUtcTicks(dateTicks: number) {
    var epochTicks = 621355968000000000; // the number of .net ticks at the unix epoch
    var ticksPerMillisecond = 10000; // there are 10000 .net ticks per millisecond

    // calculate the total number of .net ticks for your date
    return epochTicks + (dateTicks * ticksPerMillisecond);
  }
  public getHtmldecodeURI(text: string) {
    return decodeURIComponent(text);
  }

  public getHtmlEncodeString(text: string) {
    if (text)
      return text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    else
      return text;
  }

  openDialog(apiService: APIService, dialog: MatDialog, fileFolderobj: object, shareutils: ShareUtils, share: ShareLink, islocalUpdated, sharedSer: SharedService, errorMsg, sharebutton) {
    this.getSettings(apiService, dialog, true, fileFolderobj, shareutils, share, islocalUpdated, sharedSer, errorMsg, sharebutton)
  }

  getSettings(apiService: APIService, dialog: MatDialog, isopenDialog: boolean, fileFolderobj: object, shareutils: ShareUtils, share: ShareLink, islocalUpdated, sharedService: SharedService, errorMsg, sharebutton) {
    var islocal;
    if (islocalUpdated)
      islocal = false;
    else
      islocal = shareutils.getIsLocal();
    apiService.getDRMSettings(islocal)
      // .pipe(takeUntil(this.onDestroy$))
      .subscribe(sharesettings => {
        if (isopenDialog) {
          this.setDataForShareDialog(sharedService, fileFolderobj, sharesettings, fileFolderobj['types'], fileFolderobj['filefoldername'])
          sharedService.isShare$.next(true)
          //  const dialogConfig = new MatDialogConfig();
          //          dialogConfig.disableClose = true;
          //dialogConfig.data = { type: fileFolderobj['fileType'], types: fileFolderobj['types'], id: fileFolderobj['contentId'], location: fileFolderobj['locations'], name: fileFolderobj['filefoldername'], size: fileFolderobj['fileSize'], lastmodified: fileFolderobj['lastmodified'], shareSettings: sharesettings };
          //dialog.open(ShareSettingsDialogComponent, dialogConfig);
        } else {
          shareutils.saveSettings(sharesettings, fileFolderobj['locations'].includes('My files') || fileFolderobj['locations'].includes('My site'))
          shareutils.generateSharelink(fileFolderobj, share, apiService, sharesettings, this, dialog, shareutils, sharedService, errorMsg, sharebutton)
        }
      }, err => {
        if (err.errorMsg == undefined) {
          err.errorMsg = Constants.COMMON_ERR_MSG;
        }
        errorMsg.str = err.errorMsg
      });
  }

  setDataForShareDialog(sharedSer, fileFolderobj: any, share: ShareSettings, types: any, filefoldername: any) {
    var uploadShareData = new UploadShareData()
    uploadShareData.type = fileFolderobj['fileType'];
    uploadShareData.types = types;
    uploadShareData.id = fileFolderobj['contentId'];
    uploadShareData.location = fileFolderobj['locations'];
    uploadShareData.name = filefoldername;
    uploadShareData.size = fileFolderobj['fileSize']
    uploadShareData.lastmodified = fileFolderobj['lastmodified']
    uploadShareData.foldertype = fileFolderobj['foldertype']
    uploadShareData.shareSettings = share
    sharedSer.updateShareData$.next(uploadShareData)
  }

  versionCompare(v1, v2) {
    const v1Parts = v1.split('.')
    var v2Parts = v2.split('.')

    if (this.isAlphaString(v2))
      v2Parts = v2.split('-')[0]

    const length = Math.max(v1Parts.length, v2Parts.length)
    for (let i = 0; i < length; i++) {
      const value = (parseInt(v1Parts[i]) || 0) - (parseInt(v2Parts[i]) || 0)
      if (value < 0) return -1
      if (value > 0) return 1
    }
    return 0
  }

  isAlphaBet(c) {
    const CHAR_CODE_A = 65;
    const CHAR_CODE_Z = 90;
    const CHAR_CODE_AS = 97;
    const CHAR_CODE_ZS = 122;

    let code = c.charCodeAt(0);

    if (
      (code >= CHAR_CODE_A && code <= CHAR_CODE_Z) ||
      (code >= CHAR_CODE_AS && code <= CHAR_CODE_ZS)
    ) {
      return true;
    }

    return false;
  }

  /**
   * Function to check if a string is fully alpha-numeric.
   *
   * @param {string} s
   * @returns {boolean}
   */
  isAlphaString(s) {
    for (let i = 0; i < s.length; i++) {
      if (this.isAlphaBet(s[i])) {
        return true;
      }
    }

    return false;
  }
}
